import { useState } from 'react';

import { CustomAlert, Text } from '../../../../../shared/uiComponents';
import { EditSvg } from '../../../../../shared/Assets/svgIcons';
import EditAuthorizationContent from './editAuthorizationContent';

import { ActiveAuthorizationProperties } from '../../../../../redux/API/ClientAPIHelpers/insuranceAuthorizationProperties';

const EditAuthorization = ({ authorizationData }: { authorizationData: ActiveAuthorizationProperties }) => {
	const [editOpen, setEditOpen] = useState<boolean>(false);

	const editHandler = () => {
		setEditOpen(true);
	};

	return (
		<>
			<div className="actionIcon" onClick={editHandler}>
				<EditSvg />
			</div>
			<div className="actionContent" onClick={editHandler}>
				<Text title="Edit" type="psm" fontWeight="medium" />
			</div>
			<CustomAlert
				open={editOpen}
				onClose={() => setEditOpen(false)}
				title="Edit Authorization"
				Content={({ onClose }) => <EditAuthorizationContent authorizationData={authorizationData} onClose={onClose} />}
			/>
		</>
	);
};

export default EditAuthorization;
